<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import JobForm from '@/components/polyhen/job/JobForm.vue'
import { useHead } from '@unhead/vue'

definePage({
    meta: {
        action: 'view',
        subject: 'orders',
    },
})


// Get route and router
const route = useRoute()

// Form reference
const jobFormRef = ref(null)

// Determine mode and job ID
const mode = computed(() => {
    return 'edit'
})

const jobId = computed(() => {
    return route.params.id
})

useHead({
    title: 'Job',
    meta: [
        { name: 'description', content: 'Job' }
    ]
})

</script>

<template>
    <div>
        <JobForm ref="jobFormRef" :job-id="jobId" :mode="mode" />
    </div>
</template>
